// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab-module--tab--1KaJ6","isButton":"Tab-module--is-button--2GGyB","active":"Tab-module--active--1aiAs","link":"Tab-module--link--2RL_e"};